module.exports = __webpack_public_path__ + "media/images/iconPaginateFirst-1c170699784eb612f2154b3de5840114.png";